import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const PANEL_PARAMS_SCHEMA_LITERAL = {
    title: 'Schéma PanelParams',
    description: 'Décrit PanelParams',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'ID_PK', fields : ['ID'], separator : '' },
    type: 'object',
    properties: {
        ID_PK: { type: 'string', maxLength : 10 },
        ID: { type: 'number' },
        PANELTYPE: { type: 'number' },
        DENOMINATION: { type: 'string' },
        PANELPARAMS: { type: ['string', 'null'] },
    },
    required: [ 'ID', 'PANELTYPE', 'DENOMINATION', 'PANELPARAMS' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(PANEL_PARAMS_SCHEMA_LITERAL);
export type RxPanelParamsDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const PANEL_PARAMS_SCHEMA: RxJsonSchema<RxPanelParamsDocumentType> = PANEL_PARAMS_SCHEMA_LITERAL;
